import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async create(data) {
    return await axiosIns.post(obtenerUrlAPIPagos('plan-pagos-universidades'), data);
  },
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('plan-pagos-universidades'), { params: opciones.params });
  },
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIPagos(`plan-pagos-universidades/${id}`));
  },
  async remove(id) {
    return await axiosIns.delete(obtenerUrlAPIPagos(`plan-pagos-universidades/${id}`));
  },
  async findOneDetallePlanPagoConceptoUniversidadCuotaAnterior(opciones = { params: {} }) {
    return await axiosIns.get(
      obtenerUrlAPIPagos('plan-pagos-universidades/detalle-plan-pago-concepto-universidad-cuota-anterior'),
      {
        params: opciones.params,
      },
    );
  },
};
